export const UNAUTHENTICATED_STATUS_CODE = 278;

export function redirectToUnauthenticatedUrl(url: string | undefined) {
	if (url == null) {
		throw new Error("Invalid response with status code 278(=unauthenticated). Response body missing field 'url'");
	}

	window.location.replace(url);
}
